/**
 * ── LEGACY SHELL — SCHEDULED FOR DELETION ──────────────────────────────────
 *
 * The content wrapper every legacy view carried: a pale blue field between two
 * white side rails. The refresh replaced it with the canvas colour and padding,
 * which is the most visible remaining difference on a dashboard.
 *
 * Values are the originals, verbatim from `frontend_refactor` — kept here in
 * the quarantine rather than pushed into a token, since no other theme wants a
 * tinted content area.
 */
/**
 * The two values that make the field, exported because the pinned title block
 * needs them too.
 *
 * In the original, dashboardHeader rendered INSIDE this wrapper, so the tint and
 * the rails ran up behind the title block and the field began right under the
 * tab strip. Pinning the bar moved it out of the wrapper; without these it sat
 * on the flat canvas and put a 135px band of unrelated grey between the strip
 * and the field.
 */
export const LEGACY_FIELD_BG = "rgba(176, 215, 255, 0.1)";
export const LEGACY_RAIL = "10px solid white";

const scrollFrame = {
  flex: 1,
  minHeight: 0,
  overflowY: "auto" as const,
  overflowX: "auto" as const,
  display: "flex",
  flexDirection: "column" as const,
  // A screen is a shrinkable flex child of this fixed-height frame. While its
  // data loads, its content is light enough to compress into the viewport, and
  // MUI Grid's wrapped rows squash every card's reserved spinner box to a
  // sliver — then the cards "jump" open when data lands. Content height is
  // truth: taller than the frame scrolls (the loaded behavior), never shrinks.
  "& > *": { flexShrink: 0 }
};

export const legacyMainSx = {
  ...scrollFrame,
  borderLeft: LEGACY_RAIL,
  borderRight: LEGACY_RAIL,
  backgroundColor: LEGACY_FIELD_BG
};

/**
 * For the legacy screens that had no wrapper: training grades, the sales rep
 * view, the selection view.
 *
 * The point is that it adds NOTHING. Those screens carry their own padding in
 * their own JSX — training grades sits in a `padding: "10px 20px"` grid — so
 * anything here stacks on top of it. It previously fell through to the
 * refresh's `20px 24px 28px`, which pushed the grades table 24px right of where
 * the original had it while the title stayed put, and the two stopped lining up.
 */
export const legacyPlainMainSx = scrollFrame;
